import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useWindowWidth from 'utils/useWindowWidth';
import { Subjects } from 'views/QuestionsWithCategories/QuestionsWithCategories.data';
import styles from './SubjectsList.module.css';

const SubjectsList = () => {
  const [showMore, setShowMore] = useState(false);
  const router = useRouter();

  const windowWidth = useWindowWidth();
  const [subjectsListHeight, setSubjectsListHeight] = useState(0);
  const [rowSubjectsHeight, setRowSubjectsHeight] = useState(0);

  const containerWidth = useRef<HTMLDivElement | null>(null);
  const maxListHeight = () => {
    const listWidth = containerWidth?.current?.offsetWidth;
    // Вычисление максимальной высоты контейнера от кол-ва элементов
    if (listWidth)
      setSubjectsListHeight(
        Math.ceil(
          Subjects.length / Math.floor(listWidth / (windowWidth < 640 ? 90 : 96)),
        ) * (windowWidth < 640 ? 95 : 130),
      );
  };

  useEffect(() => {
    if (windowWidth > 639) {
      setRowSubjectsHeight(114);
    } else {
      setRowSubjectsHeight(90);
    }
    maxListHeight();
  }, [windowWidth]);

  const showMoreSubjectsHandler = () => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    setShowMore(false);
  }, [router]);

  return (
    <div ref={containerWidth} className={styles.subjects}>
      <div
        style={{ maxHeight: !showMore ? rowSubjectsHeight : subjectsListHeight }}
        className={`${styles.subject__list} ${showMore && styles.show_all_subjects}`}
      >
        {Subjects.map((i) => (
          <Link
            href={`${i.link}${router.query.grade ? `?klass=${router.query.grade}` : ''}`}
            key={i.imageName}
            scroll={false}
          >
            <a>
              <div className={styles.subject__item}>
                <div className={styles.subject__img}>
                  <Image
                    src={`https://static.uchi.ru/files/otvety/subjects/${i.imageName}.svg`}
                    alt={i.name}
                    width={60}
                    height={60}
                  />
                </div>
                <span className={styles.subject__name}>{i.name}</span>
              </div>
            </a>
          </Link>
        ))}
      </div>
      <button className={styles.show_more} onClick={showMoreSubjectsHandler}>
        {!showMore ? 'Показать все предметы' : 'Показать меньше предметов'}
      </button>
    </div>
  );
};

export default SubjectsList;
